import type { BindFeature } from '@wix/thunderbolt-catharsis-ioc'
import { CssFeatureSymbol } from '../../ioc/catharsis-ioc'
import type { PresetsCssFeature } from './presets.types'
import { presets } from './presetCompNode'
import { presetsDomApplier } from './presetsDomApplier'

export const presetsCssFeature: PresetsCssFeature = {
	featureName: 'presets',
	experimentName: 'OPEN_TO_ALL',
	renderableNodes: { presetsOutput: presets },
	intermediateNodes: {},
	dataMaps: ['variants_data', 'presets'],
	domApplier: presetsDomApplier,
}

export const page: BindFeature = (bind) => {
	bind(CssFeatureSymbol).toConstantValue(presetsCssFeature)
}
export const editor: BindFeature = page
